import {
  Component,
  Input,
  OnInit,
  ElementRef,
  Renderer2,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { AuthService } from "./../Services/auth.service";
import { CommonService } from "./../Services/common.service";

import { TranslateService } from "@ngx-translate/core";
import { ErrorMessageKeyService } from "./../Services/error-message-key.service";
import { KycService } from "./../Services/kyc.service";
import { CountriesService, Country } from "../Services/countries.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import * as config from "src/assets/i18n/en.json";

import { Guid } from "guid-typescript";
import { ConfigService } from "../Services/config.service";

@Component({
  selector: "app-mobile-otp",
  templateUrl: "./mobile-otp.component.html",
  styleUrls: ["./mobile-otp.component.scss"],
})
export class MobileOtpComponent implements OnInit {
  filterTerm: string;

  counter: string;
  current: string;
  max: string;
  code: string;
  submitAttempt: boolean = false;
  public verify: string = "";
  backSubscription;
  timerexpire: string;
  timeoutHandle;
  type: string = "";
  mobileSuccess: boolean = false;
  resendOptbtnShow: boolean = false;
  loginResponse;
  maxNumber: number = 0;
  _number: string = "";
  mobilemaxlength: number;
  mobileminlength: number;
  selectedMobile: Country;
  IsUSMobileNo;
  mask;
  numberPlaceHolder: string = "";
  mobilelist;
  uniqueId: Guid;
  id: string;
  @Input() numbertext: string;
  registerForm: FormGroup;
  SecondForm: FormGroup;
  newmobile;
  mobilelistrender: boolean = false;

  @ViewChild("modal") Modal: ElementRef;
  @ViewChild("customDropdownList") customDropdownList: ElementRef;

  checkDropDownStatus: boolean = false;

  selectedDropNumber: string = "";

  selectedIcon: string;
  selectAssignNumber: string;

  _otp;

  constructor(
    private kyc: KycService,
    public errorKey: ErrorMessageKeyService,
    private translate: TranslateService,
    private commonP: CommonService,
    private auth: AuthService,
    private _router: Router,
    private formBuilder: FormBuilder,
    public Renderer2: Renderer2,
    public countries: CountriesService,
    private cdr: ChangeDetectorRef,
    public config: ConfigService
  ) {
    this.registerForm = this.formBuilder.group({
      otp: [
        "",
        Validators.compose([Validators.required, Validators.minLength(6)]),
      ],
      recaptcha: [""],
    });
  }

  async ngOnInit(): Promise<void> {
    this.startTime();
    this.counter = "1";
    this.current = "4";
    this.max = "13";

    this.countries.mobileNumber = await this.commonP.Get("mobilenumber");
    if (!this.countries.mobileNumber) {
      this._router.navigateByUrl("MobileVerification");
    }

    this.commonP.hideLoading();
  }

  startTime() {
    var str = "0:59";
    var array = str.split(":");
    this.countdown(parseInt(array[0]), parseInt(array[1]));
  }

  isFormValid() {
    if (!this.registerForm.valid) {
      return true;
    } else {
      false;
    }
  }

  clearAll() {
    this.verify = "";
  }

  countdown(minutes, seconds) {
    this.timeoutHandle;
    var that = this;
    function tick() {
      that.timerexpire =
        minutes.toString() + ":" + (seconds < 10 ? "0" : "") + String(seconds);
      seconds--;
      if (seconds >= 0) {
        that.timeoutHandle = setTimeout(tick, 1000);
      } else {
        if (minutes >= 1) {
          setTimeout(function () {
            that.countdown(minutes - 1, 59);
          }, 1000);
        }
      }

      if (that.timerexpire == "0:00") {
        that.resendOptbtnShow = true;
      }
    }
    tick();
  }

  getMessage(key, control) {
    let error = "";
    this.translate.get([key]).subscribe((data) => {
      if (control == "newmobile") {
        if (key == "MobileMin") {
          error = data[key];
          error = error.replace("{minLength}", this.mobileminlength.toString());
        } else if (key == "MobileMax") {
          error = data[key];
          error = error.replace("{maxLength}", this.mobilemaxlength.toString());
        } else {
          error = data[key];
        }
      } else {
        error = data[key];
      }
    });
    return error;
  }

  clear() {
    this.code = "";
    this.registerForm.reset();
  }

  async SendAgain() {
    await this.commonP.presentLoading();
    this.auth.ResendMobileOTP(this.auth.accessToken).then((data: any) => {
      if (data?.response?.code == 1) {
        this.translate
          .get(["Success", "Ok", "ResendSuccess"])
          .subscribe((data) => {
            this.commonP.showSuccessAlert(
              data["Success"],
              data["ResendSuccess"],
              data["Ok"],
              this._router
            );
            this.startTime();
            this.resendOptbtnShow = false;
            this.clear();
          });
      } else {
        this.commonP.ParseErrorAlert("", "", this._router, data);
      }
    });
  }

  BacktoScreen() {
    this._router.navigateByUrl("/MobileVerification");
  }

  async verifyotp() {
    debugger
    this.countries.mobileNumber = await this.commonP.Get("mobilenumber");
    this._otp = this.registerForm.controls["otp"].value;
    this.uniqueId = Guid.create();
    this.id = this.uniqueId.toString();
    this.commonP.presentLoading();
    // this.auth
    //   .GetGeoData()
    //   .then((data: any) => {
    //     this.auth.GeoData = data;
    //     console.log(this.auth.GeoData);
    //     this.DoOTPVerification(
    //       this.auth.GeoData.geoplugin_countryName,
    //       this.auth.GeoData.geoplugin_longitude,
    //       this.auth.GeoData.geoplugin_latitude,
    //       this.auth.GeoData.geoplugin_request,
    //       this.auth.GeoData.geoplugin_city,
    //       this.auth.GeoData.geoplugin_countryCode,
    //       this.auth.GeoData.geoplugin_delay,
    //       this.auth.GeoData.geoplugin_regionCode,
    //       this.auth.GeoData.geoplugin_region,
    //       this.auth.GeoData.geoplugin_continentName,
    //       this.auth.GeoData.geoplugin_regionName,
    //       this.auth.GeoData.geoplugin_timezone
    //     );
    //   })
    //   .catch((error) => {
    //     this.DoOTPVerification("", "", "", "", "", "", "", "", "", "", "", "");
    //   });

    this.DoOTPVerification("", "", "", "", "", "", "", "", "", "", "", "");

    //
  }

  async DoOTPVerification(
    CountryName,
    Longitude,
    Latitude,
    Ip,
    City,
    CountryCode,
    PluginDelay,
    RegionCode,
    Region,
    ContinentName,
    RegionName,
    TimeZone
  ) {
    //let ip = "";
    debugger;
    let latlongdata = await this.commonP.getLocationField();
    debugger;
    this.auth
      .VerifyOTPMobile(
        this.countries.mobileNumber,
        this._otp,
        this.id,
        this.commonP.longitude,
        this.commonP.latitiude,
        "",
        Ip,
        CountryName,
        City,
        CountryCode,
        PluginDelay,
        RegionCode,
        Region,
        ContinentName,
        RegionName,
        TimeZone
      )
      .then(async (res: any) => {
        console.log(res, "VerifyOtp");
        debugger;
        if (res?.response?.code == 1) {
          this._otp = " ";
          if (
            res.response.content.l.userId == "" ||
            res.response.content.l.userId == null
          ) {
            this.commonP.delete("productId");
            this.commonP.delete("token");
            this.commonP.hideLoading();
            // this._router.navigateByUrl("/register/PakistanNationalityDetails");
            let AccountType =await this.commonP.Get("accountType");
            console.log("Nazil Hogi kia" , AccountType)


            if(AccountType=='M'){
              debugger
              console.log('MinorIdDetails');
              this._router.navigateByUrl("/minor/MinorIdDetails");

            }else if(AccountType=='A'){
              debugger
              console.log('PAK-nationality-details for AMAL');

              this._router.navigateByUrl("/PAK-nationality-details");
            }else if (AccountType=='I'){
              debugger
              console.log('PAK-nationality-details For Individual');

              this._router.navigateByUrl("/PAK-nationality-details");
            }else{
              this._router.navigateByUrl("/PAK-nationality-details");

            }
         
          } 
          else {debugger
            this.commonP.Set("UserDetails", res.response.content);
            this.commonP.Set("UserId", res.response.content.l.userId);
            this.commonP.Set("token", res.response.token);
            // this.commonP.Set("minorcomplete", res.response.content.l.onBoardingAccount.minorcomplete);


            if (
              res.response.content.l.onBoardingAccount.callStatus == "A" ||
              res.response.content.l.onBoardingAccount.callStatus == "DS"
            ) {
              this._router.navigate(["/register/ApplicationSubmitted"], {
                queryParams: { page: 40 },
              });
            } else {
              debugger
              if (res.response.content.l.onBoardingAccount?.applicationId) {
                this.commonP.Set(
                  "productId",
                  res.response.content.l.onBoardingAccount.productId
                );
              }
              debugger
              this.commonP.Set("User", JSON.stringify(res.response.content.l));

              this.auth.accessToken = await this.commonP.Get("token");
              this.auth.productID = await this.commonP.Get("productId");

              console.log("productid",this.auth.productID)
              if (this.auth.productID) {debugger
                this.kyc
                  .GetKycStatus(
                    this.auth.accessToken,
                    Number(this.auth.productID)
                  )
                  .then(async (data: any) => {
                    debugger
                    console.log(data, "GetKycStatus");
                    // this.commonP.Set('productId', data.response.content.productId)
                    if (data.response) {
                      if (data.response.code) {
                        if (data.response.code == 1) {
                          this.commonP.Set("token", data.response.token);

                          if (this.kyc.totalCount > 0) {
                            let nextscreen = this.kyc.getScreen(this.kyc.count);
                            this.commonP.hideLoading();
                            if (nextscreen == "Disclaimer") {
                            } else {
                              this._router.navigateByUrl(nextscreen);
                            }
                          } else {
                            this.commonP.ParseErrorAlert(
                              "",
                              "",
                              this._router,
                              data
                            );
                          }
                        } else {
                          this.commonP.ParseErrorAlert(
                            "",
                            "",
                            this._router,
                            data
                          );
                        }
                      } else {
                        this.commonP.ParseErrorAlert(
                          "",
                          "",
                          this._router,
                          data
                        );
                      }
                    } else {
                      this.commonP.ParseErrorAlert("", "", this._router, data);
                    }
                  });
              } else {debugger

                let AccountType =await this.commonP.Get("accountType");


                console.log('MinorIdDetails',AccountType);


                if(AccountType=='M'){
                  debugger
                  console.log('MinorIdDetails');
                  this._router.navigateByUrl("/minor/TellUsMoreAboutYourselfMinor");
                  this.commonP.hideLoading();

                }else if(AccountType=='A'){
                  debugger
                  console.log('MinorIdDetails2');

                  console.log('PAK-nationality-details for AMAL');
    
                  this._router.navigateByUrl("/register/AccountType");
                }else if (AccountType=='I'){
                  debugger
                  console.log('MinorIdDetails3');

                  console.log('PAK-nationality-details For Individual');
    
                  this._router.navigateByUrl("/register/AccountType");
                }
             else{this._router.navigateByUrl("/register/AccountType");}

                
              }
            }
          }
        } else {
          this._otp = "";

          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, res);
        }
      });
  }
  async reSendOTP() {
    this.countries.mobileNumber = await this.commonP.Get("mobilenumber");

    this.uniqueId = Guid.create();
    this.id = this.uniqueId.toString();
    console.log(this.id, "this.id");
    this.commonP.presentLoading();
    this.auth
      .RecheckMobileNumber(this.countries.mobileNumber, this.id)
      .then((data: any) => {
        console.log(data, "ResendOtp");
        if (data?.response?.code == 1) {
          this.commonP.hideLoading();
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  onCaptchaResponse(e) {
    this.registerForm.get("recaptcha").setValue(e);
  }
  onCaptchaExpired() {
    this.registerForm.get("recaptcha").setValue("");
  }
}
